import { RootState } from '../../rootReducer'

export const selectTopFiveOrganizations = (state: RootState) => state.topOrganizations.topFive
